<template>
	<div class="lock-info">
		<div>
			<Icon icon="lock"/>
		</div>
		<div>
			<template v-if="$slots.default">
				<slot/>
			</template>
			<div v-else>{{ defaultText }}</div>
		</div>
	</div>
</template>
<script>
import Icon from "@/vue/icon/Icon.vue";

export default {

	components: {
		Icon,
	},

	computed: {
		defaultText ()
		{
			return 'Diese Informationen sind im Nachhinein nicht mehr änderbar.';
		},
	},
}
</script>
